import { useIsFuture } from '@b-stock/fe-core/bstock-react'

import { parseCustomDate } from '@/helpers/dateUtils'
import type { SearchResult } from '@/queries/listingSearchQuery'

import { getGridCardPrice } from './getGridCardPrice'

/**
 * getGridCardPrice with a re-render when the Buy Now window lapses, so an
 * open page flips from the Buy Now price to the auction start price without
 * a reload - matching the card's Buy Now tag and countdown, which already
 * flip live via useBuyNowEndTimeIfActive.
 */
export const useGridCardPrice = (
  listing: SearchResult,
  auction: NonNullable<SearchResult['auction3MP']>
): number => {
  const buyNowEndTime = listing.buyNowEndTime
    ? parseCustomDate(listing.buyNowEndTime)
    : null
  useIsFuture(buyNowEndTime)

  return getGridCardPrice(listing, auction)
}
